import { IInternalAccount } from "@wingspanhq/bookkeeping/dist/lib/interfaces";

export const selectorIsMigrationInProgress = (
  bankingAccount?: IInternalAccount
  //   TODO:should we fix it on BE?
) => !!(bankingAccount as any)?.labels?.migrationInProgress;
